import { ComputedTick } from '@visx/axis'
import { Group } from '@visx/group'
import { AnyScaleBand } from '@visx/shape/lib/types'
import { getStringWidth } from '@visx/text'

export default function Tick({ ticks }: { ticks: ComputedTick<AnyScaleBand>[] }) {
  let shouldSkip = false
  for (const [i, tick] of ticks.entries()) {
    if (
      12 +
        tick.from.x +
        (getStringWidth(tick.value, {
          fontSize: `12px`,
          lineHeight: `16.8px`,
          fontWeight: 400,
          fontFamily: `Inter`,
          boxSizing: `border-box`,
        }) ?? 0) /
          2 >
      ticks[i + 1]?.from.x -
        (getStringWidth(ticks[i + 1]?.value, {
          fontSize: `12px`,
          lineHeight: `16.8px`,
          fontWeight: 400,
          fontFamily: `Inter`,
          boxSizing: `border-box`,
        }) ?? 0) /
          2
    ) {
      shouldSkip = true
      break
    }
  }
  return (
    <>
      {ticks?.map((tick, i) => (
        <Group
          className="visx-group visx-axis-tick"
          key={`vx-tick-${tick.value}-${i}`}
          opacity={shouldSkip && i % 2 !== 0 ? 0 : 1}
        >
          <svg>
            <text
              key={tick.value}
              textAnchor="middle"
              x={tick.from.x}
              y={tick.from.y + 20}
              className="fill-current text-body-xs text-default"
            >
              {tick.value}
            </text>
          </svg>
        </Group>
      ))}
    </>
  )
}
